import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import '../css/management.css';
import { Link, useParams } from 'react-router-dom';
import helpers from '../helper';
import axios from 'axios';
import ContentLoader from 'react-content-loader';
import Datanotfound from './layout/Datanotfound';

export default function Managementdetail() {
    const { alias } = useParams();
    const [member, setMember] = useState(null);
    const [pageloader, setPageloader] = useState(false);

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/managementteam/' + alias)
                .then((response) => {
                    setMember(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [alias]);

    return (
        <>
            <Helmet>
                <title>{member ? member.name + ' : PES Installations Limited' : 'Board of Directors : PES Installations Limited'}</title>
                <meta name="description" content={member ? member.name + ' - ' + member.designation : 'Board of Directors'} />
            </Helmet>
            <main className='Sec5'>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Management Team" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">{member ? member.name : 'Board of Directors'}</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><Link to="/board-of-directors">Board of Directors</Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">{member ? member.name : ''}</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="TeamSec TeamDetail">
                    <div className="container">
                        {
                            pageloader ?
                                <ContentLoader height={420} width={1660} backgroundColor="#f5f5f5" foregroundColor="#dbdbdb">
                                    <rect x="30" y="20" rx="8" width="380" height="380" />
                                    <rect x="450" y="30" rx="4" width="500" height="28" />
                                    <rect x="450" y="80" rx="4" width="300" height="18" />
                                    <rect x="450" y="130" rx="4" width="1100" height="12" />
                                    <rect x="450" y="155" rx="4" width="1100" height="12" />
                                    <rect x="450" y="180" rx="4" width="1000" height="12" />
                                </ContentLoader>
                                :
                                member ?
                                    <div className="row">
                                        <div className="col-lg-4 col-md-5 mb-4">
                                            <div className="TeamCard text-center">
                                                {
                                                    helpers.helpers1(member.image) ?
                                                        <picture className="img">
                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/management/' + member.image} alt={member.name} className="w-100" width="400" height="400" />
                                                        </picture>
                                                        :
                                                        <picture className="img">
                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/management/webp/' + member.image + '.webp'} type="image/webp" />
                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/management/jpg/' + member.image + '.jpg'} alt={member.name} className="w-100" width="400" height="400" />
                                                        </picture>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-7">
                                            <h2 className="mb-1">{member.name}</h2>
                                            <p className="text-muted">{member.designation}</p>
                                            <div className="TeamBio" dangerouslySetInnerHTML={{ __html: member.description }}></div>
                                        </div>
                                    </div>
                                    :
                                    <Datanotfound />
                        }
                    </div>
                </section>
            </main>
        </>
    )
}
